import type { GlobalSearchTab } from '@plato/search/search-types';
import { createContext } from 'react';

export type GlobalSearchContextType = {
    openSearch: (defaultTab?: GlobalSearchTab) => void;
    open: boolean;
};

// this should be away from the global search provider, so it doesn't get
// recreated on HMR
export const GlobalSearchContext = createContext<GlobalSearchContextType | undefined>(undefined);
